













import { Component, Prop, Vue } from 'vue-property-decorator';
import { MetaInfo } from '@/interfaces/meta-info.interface';

@Component
export default class MetaOverlay extends Vue {
  @Prop() private msg!: string;
  @Prop() private info: any;
}
